import * as React from 'react';
const SvgTraingleFillDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.756 13.127a1 1 0 0 1-1.512 0L6.237 9.655A1 1 0 0 1 6.993 8h6.014a1 1 0 0 1 .756 1.655z"
    />
  </svg>
);
export default SvgTraingleFillDown;
